import {connect} from 'react-redux'
import {
    ActionsRow,
    commons,
    FixedDropDownButton,
    Icon,
    Loader,
    modal,
    utils
} from "@mc/mc-legacy";
import {Button, ButtonToolbar, CardBody, Col, DropdownItem, NavItem, NavLink, Row} from "reactstrap";
import AdminPage from "./AdminPage";
import * as subjektActions from "../../actions/subjektActions";
import * as polozkaActions from "../../actions/polozkaActions";
import {formatDate, getIdFromProps} from "../../utils/utils";
import {LinkContainer} from "react-router-bootstrap";
import TablePanel from "../../components/TablePanel";
import CenikForm from "../../forms/CenikForm";
import PolozkaApi from "../../api/gen/cgo/PolozkaApi";
const {sinkEvent} = commons;
import {ADMIN_BASE_PATH, SPOLECNOSTI_PATH} from "../../const/routes";
import {Component} from "react";
import * as React from "react";
import {withTranslation, WithTranslation} from "react-i18next";

/**
 * Stránka administrace - seznam ceníků
 */
class CenikyPage extends Component<WithTranslation> {

    componentDidMount() {
        this.fetchData();
    }

    componentDidUpdate() {
        this.fetchData();
    }

    fetchData = () => {
        this.props.dispatch(polozkaActions.fetchCenikyIfNeeded(null));
    };

    handleShowCenik = (cenik) => {
        this.props.history.push(`/${ADMIN_BASE_PATH}/ceniky/${cenik.id}`);
    };

    handleCreateCenik = () => {
        const {t} = this.props;
        this.props.dispatch(modal.ModalActions.show(
            CenikForm,
            {
                onSubmit: (data) => {
                    return PolozkaApi.createCenik({...data});
                },
                onSubmitSuccess: (result, dispatch) => {
                    dispatch(modal.ModalActions.hide());
                    dispatch(polozkaActions.invalidateCeniky());
                },
                onClose: () => this.props.dispatch(modal.ModalActions.hide()),
            },
            t('new_price_list'),
            {size: "sm"}
        ));
    };

    handleEditCenik = (cenik) => {
        const {t} = this.props;
        this.props.dispatch(modal.ModalActions.show(
            CenikForm,
            {
                onSubmit: (data) => {
                    return PolozkaApi.updateCenik(data, cenik.id);
                },
                onSubmitSuccess: (result, dispatch) => {
                    dispatch(modal.ModalActions.hide());
                    dispatch(polozkaActions.invalidateCeniky());
                },
                onClose: () => this.props.dispatch(modal.ModalActions.hide()),
                initialValues: cenik,
            },
            t('price_list_change'),
            {size: "sm"}
        ));
    };

    handleDeleteCenik = (cenik) => {
        const {t} = this.props;
        this.props.dispatch(
            modal.ModalActions.showConfirm(
                t('price_list_delete'),
                <span>{t('price_list_delete_including_items',{priceListId: cenik.id})}</span>,
                () => {
                    PolozkaApi.deleteCenik(cenik.id).then(() => {
                        this.props.dispatch(polozkaActions.invalidateCeniky());
                    });
                },
                null,
                t('delete')
            )
        );
    };

    renderContextMenu = (cenik) => {
        const {t} = this.props;
        return <FixedDropDownButton color="action action-hover" noCaret title={<Icon icon="ellipsis-v"/>}>
            <DropdownItem key="0" onClick={sinkEvent(this.handleShowCenik.bind(this, cenik))}>{t('show_detail')}</DropdownItem>
            <DropdownItem key="1" onClick={sinkEvent(this.handleEditCenik.bind(this, cenik))}>{t('edit')}</DropdownItem>
            <DropdownItem key="2" onClick={sinkEvent(this.handleDeleteCenik.bind(this, cenik))}>{t('delete')}</DropdownItem>
        </FixedDropDownButton>
    }

    render() {
        const {cenikyList, t} = this.props;

        if (!cenikyList.fetched) {
            return <Loader/>;
        }

        let content;
        if (cenikyList.rows.length !== 0) {
            content = cenikyList.rows.map(cenik => {
                return <CardBody key={cenik.id}>
                    <ActionsRow actions={this.renderContextMenu(cenik)} onClick={this.handleShowCenik.bind(this, cenik)}>
                        <Row>
                            <Col xs={1}>{cenik.id}</Col>
                            <Col xs={3}>{cenik.nazevCenik}</Col>
                            <Col xs={3}>{cenik.aktivniOd ? formatDate(cenik.aktivniOd, "YYYY-MM-DD") : "-"}</Col>
                            <Col xs={3}>{cenik.aktivniDo ? formatDate(cenik.aktivniDo, "YYYY-MM-DD") : "-"}</Col>
                        </Row>
                    </ActionsRow>
                </CardBody>;
            });
        } else {
            content = <CardBody><i>{t('no_price_list')}</i></CardBody>
        }

        return <AdminPage
                title={t('admin.price_list_many')}
                subtitle={t('admin.price_list_info')}
                content={
                    <div>
                        <ButtonToolbar>
                            <Button color="primary" onClick={this.handleCreateCenik}>{t('new_m')}</Button>
                        </ButtonToolbar>
                        <TablePanel header={
                            <Row>
                                <Col xs={1}>{t('labels.id')}</Col>
                                <Col xs={3}>{t('labels.name')}</Col>
                                <Col xs={3}>{t('active_from')}</Col>
                                <Col xs={3}>{t('active_to')}</Col>
                            </Row>
                        }>
                            {content}
                        </TablePanel>
                    </div>
                }
            />
    }
}

function mapStateToProps(state) {
    return {
        cenikyList: utils.storeFromArea(state, polozkaActions.CENIKY_LIST_AREA),
    }
}

export default connect(mapStateToProps)(withTranslation()(CenikyPage));

